import { Link } from "react-router-dom";
import { styleForCategory } from "../lib/visual";
import styles from "./CategoryTile.module.css";

type Props = {
  id: string;
  name: string;
  count?: number;
};

export default function CategoryTile({ id, name, count }: Props) {
  const style = styleForCategory(id);
  return (
    <Link
      to={`/search?category=${id}`}
      className={styles.tile}
      style={{ background: style.gradient }}
    >
      <span className={styles.glyph} aria-hidden>
        {style.glyph}
      </span>
      <div className={styles.body}>
        <div className={styles.name}>{name}</div>
        {count !== undefined && (
          <div className={styles.count}>{count} events</div>
        )}
      </div>
      <span className={styles.arrow} aria-hidden>
        →
      </span>
    </Link>
  );
}
